import $ from "jquery";

$(() => {
  if (document.querySelector('.contact-page')) {
    if (document.querySelector('main .wpcf7-form')) {
      console.log(document.querySelector('main .wpcf7-form'));
      $("textarea").attr('rows', 6);
  
      let agentArray = [];
      
      let agentDiv = $("#agent-array").children("div");
  
      let initial = {
        name: $("#agent-list")[0].value,
        email: $("#agent-email")[0].value,
      }
      agentArray.push(initial);
  
      agentDiv.each((i, div) => {
        let name = $(div).children("#agent-name").text();
        let email = $(div).children("#agent-email").text();
        let agent = {
          name: name,
          email: email,
        };
        agentArray.push(agent);
      });
  
      $("#agent-list").on('change', function() {
        let name = this.value;
        let email = agentArray[0].email;
        for(let i = 0; i < agentArray.length; i++) {
          if( name === agentArray[i].name ){
            email = agentArray[i].email;
          };
        }
        $("#agent-email").attr("value", email);
        $("#agent-email").text(email);
      });
  
      const resetButton = $('.form-reset');
      resetButton.detach().insertAfter('.wpcf7-response-output');
  
      $(resetButton).on('click', function() {
        $('.wpcf7-form').trigger('reset');
      });
    }

    // let hubspotForms = $("main .wp-block-leadin-hubspot-form-block")
    // let hubspotPlaceholder = $("main .hubspot-placeholder");
    // console.log('form: ', hubspotForms);
    // if(hubspotForms.length) {
    //   console.log('form if: ', hubspotForms);
    //   hubspotForms.each((i, hubspotFormEl) => {
    //     const hubspotForm = $(hubspotFormEl);
    //     hubspotForm.detach().appendTo(hubspotPlaceholder);
    //     // console.log($(".hs-input"));
    //     // $(".hs-input").style.padding = '12px';
    //     let cssLink = document.createElement("link");
    //     cssLink.href = "../app/themes/londonpacific/dist/styles/app.css";
    //     cssLink.rel = "stylesheet";
    //     cssLink.type = "text/css";
    //     setTimeout(() => {
    //       let iframe = document.getElementById("hs-form-iframe-0").contentDocument.head;
    //       iframe.appendChild(cssLink);
    //       console.log('iframe: ', iframe);
    //       console.log('style: ', cssLink);
    //     }, 500);
    //   });
    // }
  }
});

function loadHubspotStyle() {
  let hubspotForms = $(".hubspot-form");
  console.log('forms: ', hubspotForms);
  if(hubspotForms.length) {
    hubspotForms.each((i, hubspotFormEl) => {
      const hubspotForm = $(hubspotFormEl);
      // console.log('form each: ', hubspotForm);
      let cssLink = document.createElement("link");
      cssLink.href = "//" + window.location.host + "/app/themes/londonpacific/dist/styles/app.css";
      cssLink.rel = "stylesheet";
      cssLink.type = "text/css";
      let fontLink = document.createElement("link");
      fontLink.href = "//" + window.location.host + "/app/themes"
      setTimeout(() => {
        let iframe = hubspotForm.find(".hs-form-iframe")[0].contentDocument.head;
        iframe.appendChild(cssLink);
        console.log('iframe: ', iframe);
        console.log('style: ', cssLink);
      }, 500);
    });
  }
}

loadHubspotStyle();